<template>
  <div class="web-box-all">
    <ext-header></ext-header>

    <div class="web-home-main">
      <div class="web-order-state">
        <h2>
          <p>快递单号：{{order_info.logistics_no}}  <b> ( 订单编号：{{order_info.erp_order_no!='' ? order_info.erp_order_no : order_info.order_no}} )</b> </p>
          <a>物流查看</a>
        </h2>
      </div>

      <div class="web-order-main">
        {{logisticsMsg}}
        <div class="bg-white" style="width: 92%; margin-left: 4%;margin: auto;padding-left: 15px;padding-right: 15px; overflow:hidden;">
        <div>
          <div class="track-rcol">
          <div class="track-list">
            <ul>
              <div v-for="(vo,index) in logisticsList" :key="index">
                <li v-if="index==0" class="first">
                  <div></div>
                  <i class="node-icon"></i>
                  <span class="txt">{{vo.context}}</span>
                  <span class="time">{{vo.time}}</span>
                </li>
                <li v-if="index!=(logisticsList.length-1) && index!=0">
                    <div></div>
                    <i class="node-icon"></i>
                    <span class="txt">{{vo.context}}</span>
                    <span class="time">{{vo.time}}</span>
                </li>
                <li v-if="index==(logisticsList.length-1) && index!=0" class="finall">
                  <div></div>
                  <i class="node-icon"></i>
                    <span class="txt">{{vo.context}}</span>
                    <span class="time">{{vo.time}}</span>
                </li>
              </div>
            </ul>
          </div>
          </div>
        </div>
        </div>
      </div>
    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl} from '@/utils/extend'

export default {
  name: 'logistics_info',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter
  },
  data () {
    return {
      title: '订单详情',
      web_url: webUrl(),
      pay_win_state: 0,
      header_title: '',
      order_no: '',
      delivery_way: '',
      order_info: {},
      goods_list: [],
      logisticsList: [],
      logisticsMsg: '暂无物流信息'
    }
  },
  mounted () {
    var params = this.$route.query
    var orderNo = Decrypt(params.v)

    this.load_data(orderNo)
    this.logistics_info_json(orderNo)
  },
  methods: {
    load_user () {
      var that = this
      ajax({
        url: '/store/user/user_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.user_info = ret.data
        }
      })
    },
    logistics_info_json (orderNo) {
      var that = this
      ajax({
        url: '/store/api/logistics_info_json',
        method: 'post',
        data: {
          uid: getUserId(),
          order_no: orderNo
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.logisticsMsg = ''
          that.logisticsList = ret.data
        }
      })
    },
    load_data (orderNo) {
      var that = this
      ajax({
        url: '/store/order/order_show',
        method: 'post',
        data: {
          uid: getUserId(),
          order_no: orderNo
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.header_title = ret.data.order_info.order_state_name
          that.order_info = ret.data.order_info
          that.goods_list = ret.data.goods_list
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-order-state { width:100%; height:50px; margin-top:15px;border-left:3px solid #d81e06;}
    .web-order-state h2 { width:100%; height:50px;  margin:0px;line-height:50px; justify-content:space-between; padding:0px 20px; border:1px solid #dfdfdf;color:#333333;}
    .web-order-state p { width:auto; height:50px; margin:0px; font-weight: bold; padding:0px; line-height:50px; font-size:14px; color:#333333; }
    .web-order-state p b { font-weight: normal; font-size:12px;}
    .web-order-state a { width:auto; height:50px; line-height:50px;  font-size:12px; color:#333333;}
    .web-order-state a:hover { color:#333333;}

.web-order-main { width:100%; height:auto; padding:20px; margin-top:15px; border:1px solid #dfdfdf; flex-wrap:wrap; align-content:flex-start;}
    .web-order-address { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
    .web-order-address h2 { width:100%; height:30px; line-height:30px; font-size:14px; font-weight: bold; margin:0px; padding:0px; color:#333333;}
    .web-order-address ul { width:100%; height:auto; list-style:none; margin:0px; padding:0px; display: flex; flex-flow:row; align-content:flex-start; flex-wrap:wrap;}
    .web-order-address ul li { width:50%; height:30px; margin:0px; padding:0px;}
    .web-order-address ul li p { width:100%; height:30px; margin:0px; padding:0px; line-height:30px; font-size:12px; color:#333333;}
    .web-order-address-line { width:100%; height:5px; margin-top:15px; background-size: auto 100%; background-image:url('../../assets/icon/order_address_line.png'); background-repeat : repeat-x;}

.web-order-info-title { width:100%; height:auto; margin-top:10px; border-bottom: 1px solid #dfdfdf; flex-wrap:wrap; align-content:flex-start;}
    .web-order-info-title h2 { width:100%; height:30px; line-height:30px; font-size:14px; font-weight: bold; margin:0px; padding:0px; color:#333333;}
    .web-order-info-title p { width:100%; height:30px; line-height:30px; font-size:14px; }
    .web-order-info-title p div.custom-radio { cursor: pointer;}
    .web-order-info-title h2 span { font-size:12px; color:#666666; font-weight: normal; margin-left:20px;}

    .web-order-info-integral { width:100%; height: 50px; margin-top:10px;}
        .web-order-info-integral-input { width:200px; height: 30px; border:1px solid #dfdfdf;}
            .web-order-info-integral-input input { width:190px; height:20px; border:0px; margin-top:5px; line-height:20px; font-size:12px; padding:0px 15px;}
        .web-order-info-integral-button { width:100px; height:30px; border:1px solid #d81e06; margin-left:10px;}
            .web-order-info-integral-button p { width:100px; cursor: pointer; height:30px;  text-align: center; line-height: 30px; justify-content:center; font-size:12px; color:#d81e06;}
  .web-cart-list-data { width:100%; height:auto; margin-top:0px; border-left:1px solid #dfdfdf; border-bottom:1px solid #dfdfdf; border-right:1px solid #dfdfdf;}
 .web-cart-list-goods { width:210px; height:auto; line-height:40px; font-size:12px; flex-wrap:wrap; align-content:flex-start; color:#333333;}
  .web-cart-list-goods p { width:100%; height:auto; line-height:20px; margin-top:15px; font-size:12px; color:#333333;}
  .web-cart-list-goods a { width:100%; height:auto; line-height:20px; font-size:12px; color:#aaaaaa;}
  .web-cart-list-goods a:hover { color:#aaaaaa;}
  .web-cart-list-props {width:140px; height:auto; line-height:40px; font-size:12px; color:#333333;}
  .web-cart-list-props p { width:100%; height:auto; line-height:20px; margin-top:15px; font-size:12px; color:#333333;}
  .web-cart-list-price {width:120px; height:auto; line-height:80px; font-size:12px; color:#333333;}
  .web-cart-list-price p { width:100%; height:auto; line-height:80px; margin-top:15px; font-size:12px; color:#333333;}
  .web-cart-list-quantity { width:360px; height:auto; text-align: center; justify-content:flex-end; line-height:40px; font-size:12px; color:#333333;}
  .web-cart-list-quantity p { width:136px; height:40px; line-height:40px; overflow: hidden; flex-flow:row; justify-content:flex-start; margin-top:35px;}
  .web-cart-list-quantity p a { width: 40px; height: 40px; cursor: pointer; background: #efefef; font-size:28px; color:#333333; line-height:34px; text-align: center; justify-content:center;}
  .web-cart-list-quantity p input { width:55px; height:38px; line-height:38px; text-align: center; font-size:12px; color:#333333; border:0px; min-height: 20px;}
  .web-cart-list-sum { width:120px; height:auto; line-height:40px; font-size:12px; color:#333333;}
  .web-cart-list-sum p { width:100%; height:auto; line-height:20px; margin-top:15px; font-size:12px; color:#333333;}
  .web-cart-list-action { width:100px; height:auto; line-height:40px; text-align: center; justify-content:center; font-size:12px; color:#333333;}
  .web-cart-list-action a { width:100%; height:auto; cursor: pointer; text-align: center; justify-content:center; line-height:20px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-checkbox { width:110px; height:auto; line-height:40px; font-size:12px; color:#333333;}
  .web-cart-list-checkbox img { width:80px; height:80px; cursor: pointer; margin:15px 0px 15px 15px;}

  .web-order-goods-box { width:100%; height:auto; margin-top:10px; border-top:1px solid #dfdfef; flex-wrap:wrap; align-content:flex-start;}

.web-order-footer { width:100%; height:auto; flex-wrap:wrap; margin-top:15px;  align-content:flex-start;}
    .web-order-footer ul { width:100%; height:auto; margin:0px; padding:0px 15px; flex-wrap:wrap; align-content:flex-start;}
    .web-order-footer ul.money {  height:90px; background: #f4f4f4; padding-top:15px; border-top:1px solid #dfdfdf;}
    .web-order-footer ul li { width:100%; height:30px;margin:0px; padding:0px; justify-content:flex-end;}
    .web-order-footer ul li p { width:70px; height:30px;margin:0px; padding:0px; line-height:30px; color:#333333; font-size:12px;}
    .web-order-footer ul li a { min-width:120px; height:30px; line-height:30px; color:#333333; font-size:12px; text-align: right; justify-content:flex-end;}
    .web-order-footer ul li a:hover { color:#333333;}
    .web-order-footer ul li a span { color:#999999; margin-left:5px;}
    .web-order-footer ul li a span.select { color:#E6A23C;}
    .web-order-footer ul li a.red { color:#d81e06; font-size:18px; font-weight: bold;}
    .web-order-footer h2 { width:100%; height:50px; margin-top:15px; justify-content:flex-end;}
    .web-order-footer h2 a {width:120px; height:30px; margin-left:15px; cursor: pointer;border: 1px solid #dfdfdf; line-height:30px; border-radius: 4px; text-align: center; justify-content:center; background: #ffffff; font-size:14px; color:#333333;}
    .web-order-footer h2 a:hover { color:#333333;}
    .web-order-footer h2 a.red { color:#ffffff; background: #d81e06;border: 1px solid #d81e06;}
    .web-order-footer h2 a.red:hover { color:#ffffff;}

#textarea { font-size:12px;}

.track-rcol{}
.track-list{
position:relative; flex-wrap:wrap; align-content:flex-start;
}
.track-list ul {
position:relative; flex-wrap:wrap; align-content:flex-start; width:800px;
}
.track-list li{
position:relative;
width:800px;
padding:0px 0 1.5rem 25px;
line-height:12px;
border-left:1px solid #d9d9d9;
color: #999;
list-style:none;
font-size: 12px;
}
.track-list li.first{
color:red;
padding-top:0;
width: 100%;
text-align: left;
border-left:1px solid #d9d9d9;
}
.track-list li .node-icon{
position: absolute;
left: -4.5px;
border-radius: 0.25rem;
width: 0.5rem;
height: 0.5rem;
top:4px;
background-color: #999999;
}
.track-list li.first .node-icon{
background-position:0-72px;
background-color: red;
width: 12px;
z-index: 2;
height: 12px;
position: absolute;
left: -7px;
top: 0;
border-radius: 0.5rem;
}
.track-list li .time{
margin-right:20px;
position:relative;
top:4px;
display:inline-block;
vertical-align:middle;
background-color: white;
color: #999;
width: 100%;
text-align: left;
}
.track-list li .txt{
position:relative;
display:inline-block;
vertical-align:top;
line-height:20px;
color: #999;
}
.track-list li.first .time{
text-align: left;
width: 90%;
color:red;
}
.track-list li.first .txt{
color: red;
text-align: left;
width: 90%;
}
.track-list li.finall{
position:relative;
padding:0px 0 1.5rem 25px;
line-height:18px;
border-color: white;
border-left:1px solid #ffffff;
color: #999;
}
.track-list li.finall .div-spilander{
width: 1px;
position: absolute;
position: absolute;
left: -1.5px;
height: 0.5rem;
background-color: #d9d9d9;
}

</style>



// WEBPACK FOOTER //
// src/pages/order/logistics_info.vue